module.exports = __webpack_public_path__ + "img/Logo3040.fe7ae17e.png";